import { Injectable, signal, effect, computed } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';

// Service declaer here...
import { GlobalFilterService } from '../filters/global-filter.service';



@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  // Calender data - done
  // Hierarchy stack - done
  // Account details - done
  // Brand details  - done
  // Manager Details  - done
  // projectType = done
  // universalFilter - done

  // Declear constructor
  constructor(
    private globalFilterService: GlobalFilterService
  ) {
    effect(() => {
      if (this.initialized()) {
        // console.log("=====================================")
        // console.log('AppState changed in component:', this.appState());
        // console.log("=====================================")
      }

    });
  }

  private isInitialized = signal(false);
  get initialized() {
    return this.isInitialized;
  }

  // Variable declear and initilized the default value
  app_state = {}
  startDate: any = moment().startOf('month');
  endDate: any = moment().startOf('day');
  activeRangeType = {
    label: "This Month",
    type: "month",
    value: 3,
    active: true
  }

  appliedDateFilters = {
    formatedStartDate: this.startDate.format("DD MMM' YY"),
    formatedEndDate: this.endDate.format("DD MMM' YY"),
    startDate: this.startDate.format("YYYYMMDD"),
    endDate: this.endDate.format("YYYYMMDD"),
    isCustomDateRangeSelected: false,
    isPresetActive: true,
    isRequestDate: true, //routing
    selectedTrend: this.activeRangeType.value,
    trendType: this.activeRangeType.type,
    dateFilterType: 1,
    is_brand_creation_date_range: false
  }

  // Signal declear with default value
  appState = signal({
    brandDetails: {},
    accountDetails: {},
    managerAccess: {},
    brandListDetails: {},
    isAccount: false,
    projectType: {},
    accessObject: {},
    datePicker: {},
    hierarchyStack: [],
    universalFilter: {},
    huddleFilters:{}
  });

  // Computed signals to efficiently track changes
  brandDetails = computed(() => this.appState().brandDetails);
  accountDetails = computed(() => this.appState().accountDetails);
  managerAccess = computed(() => this.appState().managerAccess);
  brandListDetails = computed(() => this.appState().brandListDetails);
  isAccount = computed(() => this.appState().isAccount);
  projectType = computed(() => this.appState().projectType);
  accessObject = computed(() => this.appState().accessObject);
  datePicker = computed(() => this.appState().datePicker);
  hierarchyStack = computed(() => this.appState().hierarchyStack);
  universalFilter = computed(() => this.appState().universalFilter);
  huddleFilters = computed(() => this.appState().huddleFilters);

  // Other method declear 

  getDefaultAccess() {
    this.globalFilterService.getDefaultAccess((parameter) => {
      return parameter
    });
  }
  
  
  // Update signal values

  updateHierarchyStack(hierarchyStack) {
    if(this.initialized() && this.generateHash(this.app_state['hierarchyStack']) !== this.generateHash(hierarchyStack)){
      this.appState.update(current => ({ ...current, hierarchyStack: hierarchyStack }));
      this.app_state['hierarchyStack'] = hierarchyStack;
    }
  }

  updateAccess(hierarchyStack, universalFilter) {
    if (this.initialized() && this.generateHash(this.app_state['hierarchyStack']) !== this.generateHash(hierarchyStack) && (!_.isEmpty(universalFilter) && this.generateHashForObject(this.app_state['universalFilter']) !== this.generateHashForObject(universalFilter))) {
      this.appState.update(current => ({ ...current, hierarchyStack: hierarchyStack, universalFilter: universalFilter }));
      this.app_state['hierarchyStack'] = hierarchyStack;
      this.app_state['universalFilter'] = universalFilter;
    } else if (!hierarchyStack && _.isEmpty(hierarchyStack) && (!_.isEmpty(universalFilter) && this.generateHashForObject(this.app_state['universalFilter']) !== this.generateHashForObject(universalFilter))) {
      this.appState.update(current => ({ ...current, universalFilter: universalFilter }));
      this.app_state['universalFilter'] = universalFilter;
    } else {
      this.appState.update(current => ({ ...current, hierarchyStack: hierarchyStack, universalFilter: universalFilter }));
      this.app_state['hierarchyStack'] = hierarchyStack;
    }
  }

  private generateHash(arr): string {
    if (arr !== undefined && !_.isEmpty(arr)) {
      return arr.map(obj => `${obj.field_id}-${obj.group_key}`).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }
  
  private generateHashForObject(obj) {
    if (obj !== undefined && !_.isEmpty(obj)) {
      return _.reduce(obj, (result:any, value:any, key:any) => {
        if(result != ''){
          result += "|"
        }
        result += key + "_" + JSON.stringify(value);
        return result;
      }, ''); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }

  updateCalendarData(dateObject) {
    this.app_state['datePicker'] = dateObject;
    this.appState.update(current => ({ ...current, datePicker: dateObject }));
  }

  updateBrandDetails(brandDetails) {
    Helpers.brandDetails = brandDetails;
    this.appState.update(current => ({ ...current, brandDetails: brandDetails }));
  }

  updateBrandListdetailsForAccount(brandListDetails) {
    this.appState.update(current => ({ ...current, brandListDetails: brandListDetails }));
  }

  updateManagerDetails(managerAccess) {
    this.appState.update(current => ({ ...current, managerAccess: managerAccess }));
  }

  updateProjectType(projectTypeOption) {
    if (this.app_state['projectType'] && (this.app_state['projectType']['project_type'] == 0 ||  this.app_state['projectType']['project_type']) && this.app_state['projectType']['project_type'] !== projectTypeOption['project_type']) {
      this.appState.update(current => ({ ...current, projectType: projectTypeOption }));
      this.app_state['projectType'] = projectTypeOption;
    }
  }

  updateUniversalFilters(universalFilter) {
    this.appState.update(current => ({ ...current, universalFilter: universalFilter }));
  }
  
  updateHuddleFilters(huddleFilters) {
    this.appState.update(current => ({ ...current, huddleFilters: huddleFilters }));
  }

  updateIsAccount(source) {
    if (source == 'account') {
      this.appState.update(current => ({ ...current, isAccount: true }));
    } else {
      this.appState.update(current => ({ ...current, isAccount: false }));
    }
  }

  //  Set Default for Signal - 
  collectDefaultValuesForAppState(accountDetails, brandListDetails, brandDetails, managerAccess, source, cb) {

    this.isInitialized.set(false);

    const accessDetails = this.getDefaultAccess();

    this.app_state['datePicker'] = this.appliedDateFilters;

    if (accountDetails && accountDetails != undefined) {
      this.app_state['accountDetails'] = accountDetails;
    }
    if (brandListDetails && brandListDetails != undefined) {
      if (source == 'account' && brandListDetails && !_.isEmpty(brandListDetails)) {
        this.filterProjectTypeList(brandListDetails)
      }
      this.app_state['brandListDetails'] = brandListDetails;
    }
    if (brandDetails && brandDetails != undefined && !_.isEmpty(brandDetails)) {
      this.app_state['brandDetails'] = brandDetails;
    }
    if (managerAccess && managerAccess != undefined) {
      this.app_state['managerAccess'] = managerAccess;
    }
    if (source == 'account') {
      this.app_state['isAccount'] = true;
      // this.app_state['brandDetails'] = {};
      // this.app_state['hierarchyStack'] = [];
    } else {
      this.app_state['isAccount'] = false;
    }

    if (brandDetails && brandDetails != undefined && !_.isEmpty(brandDetails)) {
      this.storeRecentVisitProject(brandDetails, managerAccess);
      this.initHierarchyFilter(brandDetails, (res, universalFilter) => {
        this.getHierarchyStack(res, (stack) => {
          if (stack && stack != undefined && stack.length > 0) {
            this.app_state['hierarchyStack'] = stack;
            if (universalFilter && universalFilter != undefined && _.hasIn(universalFilter, 'filters') && !_.isEmpty(universalFilter.filters)) {
              this.app_state['universalFilter'] = this.globalFilterService.getFormatedUniversalFilter(universalFilter.filters);
              this.globalFilterService.storeUniversalFilters(universalFilter);
            }
            this.setAppStateObject(this.app_state);
            this.isInitialized.set(true);
            cb(true)
          }
        })
      });
    } else {
      this.setAppStateObject(this.app_state);
      this.isInitialized.set(true);
      cb(true)
    }
  }

  setAppStateObject(app_state) {
    // Create a new object reference with new nested object references
    // This is critical because Angular computed signals check reference equality
    // Shallow spread won't work for nested objects - we need to spread nested objects too
    this.appState.set({
      ...app_state,
      brandDetails: app_state.brandDetails ? { ...app_state.brandDetails } : {},
      accountDetails: app_state.accountDetails ? { ...app_state.accountDetails } : {},
      managerAccess: app_state.managerAccess ? { ...app_state.managerAccess } : {},
      brandListDetails: app_state.brandListDetails ? (Array.isArray(app_state.brandListDetails) ? [...app_state.brandListDetails] : { ...app_state.brandListDetails }) : {},
      projectType: app_state.projectType ? { ...app_state.projectType } : {},
      accessObject: app_state.accessObject ? { ...app_state.accessObject } : {},
      datePicker: app_state.datePicker ? { ...app_state.datePicker } : {},
      hierarchyStack: app_state.hierarchyStack ? [...app_state.hierarchyStack] : [],
      universalFilter: app_state.universalFilter ? { ...app_state.universalFilter } : {},
      huddleFilters: app_state.huddleFilters ? { ...app_state.huddleFilters } : {}
    });
  }

  filterProjectTypeList(brandListDetails) {
    let projectOptions: any[] = [];
    const uniqueTypes = new Set < number > ();
    brandListDetails.forEach((brand: any) => {
      const projectTypeId: number = Number(brand.project_type);
      uniqueTypes.add(projectTypeId);
      const projectOptionName = this.getProjectTypeName(projectTypeId);
      if (!projectOptions.some(option => option.name === projectOptionName)) {
        projectOptions.push({ name: projectOptionName, project_type: projectTypeId });
      }
    });
    // Only add "ALL" if there is more than one unique project type and more than one project
    if (brandListDetails.length > 1 && uniqueTypes.size > 1) {
      projectOptions.unshift({ name: 'ALL', project_type: 0 });
    }
    this.app_state['projectType'] = projectOptions[0];
  }


  private getProjectTypeName(value: number): string {
    switch (value) {
      case 0: return 'ALL';
      case 1: return 'CX';
      case 2: return 'PX';
      case 3: return 'EX';
      case 4: return 'CX + PX';
      case 6: return 'AX';
      default: return '';
    }
  }


  // 1. Hierarchy mapping 
  // 2. filter out default access
  // 3. preapre hierarchy stack

  initHierarchyFilter(brandDetail, cb) {
    // Call service to get logged in manager default access
    this.globalFilterService.getDefaultAccess((parameter) => {
      let manager_type = _.get(parameter, 'manager_type');
      if (parameter && parameter['project_id'] && manager_type != 3) {
        let project_id = parameter['project_id'];
        if (brandDetail && _.has(brandDetail, 'is_single_touchpoint_setup') && brandDetail['is_single_touchpoint_setup'] == true && parameter.access_key != undefined) {
          this.globalFilterService.setMappedHierarhcyLevels(brandDetail, (data: any) => {
            let hierarchyMapping = Helpers.deepClone(data.hierarchyMapping);
            let hierarchies_search = Helpers.deepClone(data.hierarchyMapping);
            let hierarchyFilterMapping = Helpers.deepClone(data.hierarchyMapping);
            // Initialized loggedIn User Level & Value
            let loggedInUserLevel = Object.keys(parameter.access_key)[0];
            let loggedInUserValues = parameter.access_key[loggedInUserLevel].values;
            let cohortAccess: any = (parameter && _.hasIn(parameter, 'access_key.' + loggedInUserLevel + ".cohort_fields") && !_.isEmpty(parameter.access_key[loggedInUserLevel].cohort_fields)) ? parameter.access_key[loggedInUserLevel].cohort_fields : {};
            let univeralFilters: any = {}
            if (!_.isEmpty(cohortAccess)) {
              univeralFilters = this.getCohortAccessFilter(cohortAccess)
            }
            let defaultIndex = 0
            hierarchyMapping = _.map(hierarchyMapping, (object: any, index: number) => {
              if (object.key == loggedInUserLevel) {
                object.options = loggedInUserValues;
                object.value = loggedInUserValues[0];
                object.enabled = true;
                defaultIndex = index;
              }
              return object
            })
            cb(hierarchyMapping, univeralFilters);
          })
        } else {
          cb([{ key: 'touchpoints', value: ["All Touchpoints"] }], {})
        }

      } else {
        cb([{ key: 'touchpoints', value: ["All Touchpoints"] }], {})
      }

    });

  }

  // added to prepare cohort filter if user has cohort level access.
  getCohortAccessFilter(cohortAccess) {
    let filterMapping = this.globalFilterService.getGolbalFilters();
    let universalFilter = this.globalFilterService.getUniveralFilters();
    if (_.isEmpty(universalFilter)) {
      universalFilter = {
        isAppliedFromAccount: false,
        filters: []
      }
    }
    const tagFilter = filterMapping['transaction_filter'];
    let filters: any = []
    if (tagFilter && tagFilter.filters && tagFilter.filters.length) {
      _.each(cohortAccess, (data: any, key: string) => {
        const filter: any = _.find(tagFilter.filters, { field_id: key })
        console.log("filter", filter)
        if (data && data.length && filter && !_.isEmpty(filter)) {
          let details: any = [];
          _.each(data, (value: any) => {
            if (value) {
              details.push({
                "text": value,
                "value": value
              })
            }
          })
          filters.push({
            "filterType": "transaction_filter",
            "fieldId": filter?.field_id || key,
            "fieldText": filter?.name || filter?.text,
            "operator": "eq",
            "isMultiSelect": false,
            "isAccessLevelFilter": true,
            "operatorText": "Equal To",
            "valueText": data.join(","),
            "values": data,
            "labels": data,
            "details": details,
            "possibleValues": data,
            "filterText": "Metadeta",
          })
        }

      })
      if (filters && filters.length) {
        universalFilter.filters = filters;

        // this._helpers.setUniversalFilters(formatedFilters);
        return universalFilter
      } else {
        return {}
      }
    } else {
      return {}
    }

  }

  getHierarchyStack(appliedHierarchy: any, cb) {
    let stack: any = []
    _.each(appliedHierarchy, (hierarchy: any) => {
      if (hierarchy.value !== "ALL") {
        stack.push({
          "field_id": hierarchy.key,
          "group_key": [hierarchy.value]
        })
      }
    })
    cb(stack);
  }


  // to Store recent selected project
  storeRecentVisitProject(brandDetails: any, managerAccess: any): void {
    let recent_visit = JSON.parse(localStorage.getItem('RVLIST') || '{}');

    const account_id = _.get(brandDetails, 'account_id');
    const userId = _.get(managerAccess, 'manager._id');
    const key = `${account_id}-${userId}`;

    // Ensure key exists and is an array
    if (!Array.isArray(recent_visit[key])) {
      recent_visit[key] = [];
    }

    // Remove any existing project entry with same account_id and project_id
    _.remove(recent_visit[key], {
      account_id: account_id,
      project_id: _.get(brandDetails, '_id'),
    });

    // Add new visit at the start
    recent_visit[key].unshift({
      account_id: account_id,
      project_id: _.get(brandDetails, '_id'),
      name: _.get(brandDetails, 'display_name') || _.get(brandDetails, 'name'),
      project_type: _.get(brandDetails, 'project_type'),
      is_single_touchpoint_setup: _.get(
        brandDetails,
        'is_single_touchpoint_setup'
      ),
      last_visited: new Date().toISOString(),
      userId: userId,
    });

    // Keep only the latest 5 entries
    recent_visit[key] = recent_visit[key].slice(0, 5);

    localStorage.setItem('RVLIST', JSON.stringify(recent_visit));
  }

  resetAppstate(caller?: string,isUniversalFilterReset?: boolean,isHierarchFilterReset?: boolean) {
    if (caller == 'account' || caller == 'full_reset') {
      delete this.app_state["brandDetails"];
      delete this.app_state["accountDetails"];
      delete this.app_state["brandListDetails"];
      delete this.app_state["projectType"];
      delete this.app_state["accessObject"];
      delete this.app_state["datePicker"];
      delete this.app_state["hierarchyStack"];
      delete this.app_state["universalFilter"];
      delete this.app_state["huddleFilters"];
    }

    if (caller == 'full_reset') {
      delete this.app_state["brandDetails"];
      delete this.app_state["accountDetails"];
      delete this.app_state["brandListDetails"];
      delete this.app_state["projectType"];
      delete this.app_state["accessObject"];
      delete this.app_state["datePicker"];
      delete this.app_state["hierarchyStack"];
      delete this.app_state["universalFilter"];
      delete this.app_state["huddleFilters"];
      delete this.app_state["managerAccess"];
    }

    if (caller == 'project') {
      delete this.app_state["brandDetails"];
      delete this.app_state["projectType"];
      delete this.app_state["accessObject"];
      delete this.app_state["datePicker"];
      delete this.app_state["hierarchyStack"];
      delete this.app_state["universalFilter"];
      delete this.app_state["huddleFilters"];
    }
    if(caller == 'reset_universal_filter'){
      if(isUniversalFilterReset){
        delete this.app_state["universalFilter"];
      }
      if(isHierarchFilterReset){
        delete this.app_state["hierarchyStack"];
      }
    }
    this.setAppStateObject(this.app_state)
  }

  resetFilters(type: string) {
    if(type != ''){
      if (type == 'all') {
        delete this.app_state["universalFilter"];
        delete this.app_state["hierarchyStack"];
        delete this.app_state["huddleFilters"];
      }
      if (type.includes('universalfilter')) {
        delete this.app_state["universalFilter"];
      }
      if ( type.includes('hierarchystack')) {
        delete this.app_state["hierarchyStack"];
      }
      if (type.includes('huddlefilters')) {
        delete this.app_state["huddleFilters"];
      }
      this.setAppStateObject(this.app_state)
    }
   
  }

}




// How to use in Component and other service area

/*

  import effect on @angular/core

  import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';

  add on constructor - private appStateService:AppStateService
  
  if Track only datePicker changes .
  effect(() => {
    console.log('datePicker updated:', this.appStateService.datePicker());
  });
  
  if you track all appState use the below code 
  effect(() => {
      console.log('AppState changed in component:', this.appStateService.appState());
  });
  

  ===========use multiple effect START ============

  effect(() => {
      console.log('brandListDetails updated:', this.appStateService.brandListDetails());
  });

  effect(() => {
    console.log('datePicker updated:', this.appStateService.datePicker());
  });

  effect(() => {
    console.log('AppState changed in component:', this.appStateService.appState());
  });

  ===========use multiple effect END ============


*/
